import React, { useEffect, useRef } from "react";
import styled from "styled-components";

interface Props {
  adUnit: string;
  adWidth: string;
  adHeight: string;
  className?: string;
}

const KakaoAd = ({ adUnit, adWidth, adHeight, className }: Props) => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (containerRef.current) {
      const scriptEl = document.createElement("script");
      scriptEl.setAttribute("type", "text/javascript");
      scriptEl.setAttribute("src", "//t1.daumcdn.net/kas/static/ba.min.js");
      scriptEl.setAttribute("async", "true");

      containerRef.current.appendChild(scriptEl);
    }
  }, [containerRef.current]);

  return (
    <Container ref={containerRef} className={className}>
      <Ins
        className="kakao_ad_area"
        data-ad-unit={adUnit}
        data-ad-width={adWidth}
        data-ad-height={adHeight}
      />
    </Container>
  );
};

export default KakaoAd;

const Container = styled.div`
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: center;
`;

const Ins = styled.ins`
  display: none;
`;
